import {
  HANDIN_PROVIDER,
  LTI1P3_PROVIDER,
  QUIZZES_PROVIDER,
  TURNITIN_PROVIDER,
} from '@core/assignments/constants';
import { ResponsiveAssignment } from '@core/assignments/types';
import { STATUS } from './AssignmentCard/utils';
import { AssignmentUnavailableReason } from './types';

type AvailabilityParams = {
  assignment: ResponsiveAssignment;
  assignmentStatus: string | null;
  isEducator: boolean;
  isStaff: boolean;
  isProviderDisabled: boolean;
};

export const getAssignmentUnavailableReason = ({
  assignment,
  assignmentStatus,
  isEducator,
  isStaff,
  isProviderDisabled,
}: AvailabilityParams): AssignmentUnavailableReason | null => {
  if (isEducator) {
    return null;
  }

  if (isProviderDisabled) {
    return 'disabled';
  }

  const isUpcomingSupportedIntegration =
    assignmentStatus === STATUS.upcoming &&
    [HANDIN_PROVIDER, TURNITIN_PROVIDER, LTI1P3_PROVIDER].includes(
      assignment.provider
    );

  if (isUpcomingSupportedIntegration) {
    return 'upcoming';
  }

  const isStudent = !isStaff;
  const hasSubmittedQuiz = Boolean(
    assignment.isSubmitted || (assignment as any).submission?.[0]
  );

  if (
    isStudent &&
    assignment.provider === QUIZZES_PROVIDER &&
    !hasSubmittedQuiz
  ) {
    return 'quiz';
  }

  return null;
};
